__turbopack_context__.v({
  "border": "styles-module-scss-module__OzjIpq__border",
});
